<template>
  <div id="app" :style="terminalType==='PC'?'':`width:100%`">
    <el-container>
      <el-header>
        <div style="float: left">
          <span style="margin-right:10px">NiceWork</span>
        </div>
        <div v-if="terminalType==='mobile'" style="float: left;">
          <el-dropdown trigger="click" style="color:white;height:40px">
            <span class="el-dropdown-link">
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item, index) in sidebar" :key="index">
                
                <router-link style="color:black" :to="item.url" :key="item.id">
                    {{ item.text }}
                  </router-link>

              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="system-tools" v-if="userInfo">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              <span style="color: #409eff; padding-right: 30px">{{ userInfo.username }}</span>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="a">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-container>
        <el-aside v-if="terminalType==='PC'" :width="isCollapse?'40px':'150px'">
          <el-row class="tac">
            <el-col :span="24">
              <el-menu default-active="2" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b" :collapse="isCollapse">
                <template v-for="(item, index) in sidebar" @click="chioseMenue">
                  <router-link :to="item.url" :key="item.id">
                    <el-menu-item v-bind:index="index + 're'">
                      <i :class="item.icon"></i>
                      <span slot="title">{{ item.text }}</span>
                    </el-menu-item>
                  </router-link>
                </template>
              </el-menu>
            </el-col>
          </el-row>
        </el-aside>
        <el-main :class="terminalType==='PC'?'':'mobileMain'">
          
          <el-header v-if="terminalType==='PC'" style="background-color:#eaedf1">
            <div style="color:black;display:flex;cursor: pointer;float:left" @click="goBack">
              <i class='el-icon-back' style="line-height:3"></i>
              <div>返回</div>
            </div>
          </el-header>

          <el-header v-if="terminalType==='mobile'" style="background-color:white;height:30px">
            <el-button size="mini" @click="goBack" style="float:left;margin-top:10px">返回</el-button>
            
            <el-button v-if="chioseRouter.name=='首页'" type="primary" size="mini" @click="goProjects" style="float:left;margin-top:10px;margin-left:10px">项目</el-button>
            <!-- <div style="float:left;margin-left:20px;width:300px;color:#333;text-align:left;font-size:18px;font-weight:600">啦啦啦</div> -->
          </el-header>

          <div style="margin: 20px;">
            <transition>
              <router-view />
            </transition>
          </div>
        </el-main>
      </el-container>
    </el-container>

    <el-dialog :visible.sync="fullScreen" :fullscreen="true" @close="takeFullScreen(false)">
      <router-view />
    </el-dialog>
    <el-dialog :fullscreen="true" :show-close="false" :visible.sync="loginState">
      <login />
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import baseComponents from "@/components/base";
import login from "@/views/login";

export default {
  components: {
    login,
  },
  filters: {
    stateFilter(val) {
      return val === "0" ? "无效" : "有效";
    },
    roles(list) {
      const array = [];
      for (let i in list) {
        array.push(list[i].roleName);
      }
      return array.join("|");
    },
  },
  data() {
    return {
      loginDialogVisible: false,
      systemScreenFlag: false,
      rake: true,
      isCollapse: false,
    };
  },
  extends: baseComponents,
  computed: {
    ...mapGetters([
      "terminalType",
      "sidebar",
      "chioseRouter",
      "fullScreen",
      "loginState",
      "userInfo",
      "searchIconEvent",
    ]),
  },
  mounted() {
  },
  created() {
    this.getTerminal();
  },
  watch: {
    cityList: function (val) {
      if (val) {
        this.cloading = false;
      }
    },
    signs: function (val) {
      if (val) {
        this.qloading = false;
      }
    },
  },
  methods: {
    goProjects() {
      this.$router.push({path:'/projects'})
    },
    handleOpen() {},
    handleClose() {},
    handleCommand() {
      this.logout();
    },

    ...mapActions({}),
    ...mapActions("system", ["takeFullScreen", "logout", "GetTerminalTyle"]),
    // ...appMapActions({ setUserInfo: "SetUserInfo" }),
    fullScreenSystem() {
      let element = document.documentElement;
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      }
      this.systemScreenFlag = true;
    },
    getTerminal() {
      if (this._isMobile()) {
        // 手机端
        // alert('手机端')
        this.GetTerminalTyle("mobile");
      } else {
        // pc端
        // alert('pc端')
      }
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
      this.systemScreenFlag = false;
    },
    goPage() {
      this.$router.push({ name: "about" });
    },
    chioseMenue(item) {
      // eslint-disable-next-line no-console
      console.log(item);
    },
    refresh() {
      this.searchIconEvent();
    },
    goBack() {
      // eslint-disable-next-line no-console
      console.log(this.$router);
      if (window.history.length <= 1) {
        this.$router.push({ path: "/" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
html,body{
  width: 100%;
  overflow: hidden;
}
body {
  margin: 0;
}
.mobileMain {
  width: 100%;
}
.whdt {
  position: relative;
  top: 60px;
  color: black;
  right: 40px;
  cursor: pointer;
}
.dff {
  cursor: pointer;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  color: #2c3e50;
  li {
    text-align: left;
  }
  .el-header {
    background-color: #2c3e50;
    height: 60px;
    line-height: 60px;
    color: #fff;
    .system-tools {
      /*position: relative;*/
      left: 50px;
      float: right;
      i {
        margin: 10px;
      }
    }
  }
  section {
    height: 100%;
  }
  .el-aside {
    background-color: #545c64;
    height: 100%;
  }
  .el-page-header {
    height: 50px;
    line-height: 50px;
    background-color: #eaedf1;
  }
  .el-main {
    padding: 0;
  }
}
a {
  text-decoration: none;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
.rest {
  position: relative;
  top: 60px;
  color: black;
  left: 100px;
  cursor: pointer;
}
.el-dropdown {
  position: relative;
  left: 15px;
}
</style>
